import component from "./ProfileAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAttention"

export default wrapVueComponent(componentName, component)
